import { ITrackEventOrigin } from '../../services/mixpanel/types';
import { Tabs } from '../types';

import { useAppSelector } from './app-hooks';

export const isPreviewOrigin = (origin: string) => origin === ITrackEventOrigin.PREVIEW_WINDOW;

export const useOriginForEvent = () => {
    const previewModalVisible = useAppSelector((state) => state.modals.preview.visible);
    const activeTab = useAppSelector((state) => state.tabs.activeTab);

    const answersOrigin =
        activeTab === Tabs.CHAT ? ITrackEventOrigin.TOOL_RESULT_ANSWERS_LIST : ITrackEventOrigin.ANSWERS_LIST;

    return previewModalVisible ? ITrackEventOrigin.PREVIEW_WINDOW : answersOrigin;
};
